module.exports = __webpack_public_path__ + "img/bg.ccf8f76f.png";